export default (apiMethods, endpoints) => ({
    getCategories: (domainConstant) => {
        return apiMethods.get(endpoints.GET_CATEGORIES_ENDPOINT + '/' + domainConstant);
    }
})



// WEBPACK FOOTER //
// ./src/lib/api-category.js